export default "__VITE_ASSET__DXxLX5WP__"